import { ComponentBase } from "@tblabs/truffle";


export class Main extends ComponentBase<HTMLElement>
{
    constructor(className: string)
    {
        super("main");
        this.Class(className);
    }
}
